import BodyForm from './components/BodyForm'
import './styles/app.css'

function App() {
  return (
    <div className="App">
      <BodyForm />
    </div>
  )
}

export default App
